import React, { useContext } from "react";
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Tutorial components
import TutorialStep from "../TutorialStep";

// Context
// import { AuthContext } from "context"; // Not needed if passed as prop

// Images (Using a placeholder for now, ideally an asset representing connecting profiles)
// import connectImage from "assets/images/illustrations/connect-profile.png"; 

function ConnectOwnProfileStep({ open, onComplete, onSkip, user }) {
    // const { user } = useContext(AuthContext); // Removed in favor of prop

    const handleConnect = () => {
        // Navigate to profile connection or open the modal directly
        // For now, we'll mark as complete and redirect to the Connect Own Profile page if it exists separately
        // OR we trigger the existing ConnectOwnProfile logic

        // Ideally, we want to simulate the user clicking "Connect to Meta" etc.
        // For this step, we mainly want to EDUCATE them to do it.

        // Let's assume we want them to go to the Dashboard or Profile page where the button is.
        // But per request "popup asking them to connect to their own profile". 
        // We can reuse the "ConnectOwnProfile" component content if it was a standalone component without layout.
        // Since ConnectOwnProfile is a complex component, we might just redirect or instruct.

        // Current Decision: Close tutorial and Navigate to Profile page? 
        // OR: Just dismiss this and rely on the Dashboard's existing "Connect Own Profile" warnings.

        // BUT, the goal is "Popup asking them to connect". 
        // Let's make it a simple "Get Started" call to action that effectively dismisses this tutorial step
        // and ideally opens the real connection modal if possible.

        onComplete();
    };

    const dialogContent = (
        <MDBox>
            <MDBox mb={2}>
                <MDTypography variant="body2" color="text">
                    Now that your workspace is ready, the next step is to connect your social media profiles.
                    This will allow us to track your performance and generate tailored insights.
                </MDTypography>
            </MDBox>
        </MDBox>
    );

    const dialogActions = (
        <>
            <MDButton variant="gradient" color="accent" onClick={handleConnect}>
                I'm ready to connect
            </MDButton>
        </>
    );

    return (
        <TutorialStep
            open={open}
            title="Let's Get Started"
            content={dialogContent}
            actions={dialogActions}
            onClose={onSkip} // Treat closing as skipping
        />
    );
}

ConnectOwnProfileStep.propTypes = {
    open: PropTypes.bool.isRequired,
    onComplete: PropTypes.func.isRequired,
    onSkip: PropTypes.func.isRequired,
    user: PropTypes.object,
};

export default ConnectOwnProfileStep;
